export default {
    signs: state => state.signs,
    diagnoses: state => state.diagnoses,
}